import store from "./store";
import UserService from "../features/user/services/user.service";
import { types } from "./reducers/auth_reducer";
import { types as appTypes } from "./reducers/app_reducer";
import {
  clearMarketConfigFromStorage,
  fetchMarketConfig,
  getMarketConfigFromStorage,
  saveMarketConfigToStorage,
} from "./marketConfig.service";

const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

let AUTH_STATE = "IQVIA_AUTH_STATE";
if (SPAIN) {
  AUTH_STATE = "IQVIA_SPAIN_AUTH_STATE";
} else if (SAUDI) {
  AUTH_STATE = "IQVIA_SAUDI_AUTH_STATE";
} else if (EGYPT) {
  AUTH_STATE = "IQVIA_EGYPT_AUTH_STATE";
}

(function initAuthStore() {
  const localAuthState = localStorage.getItem(AUTH_STATE) ? JSON.parse(localStorage.getItem(AUTH_STATE)) : "";

  if (localAuthState) {
    store.dispatch({
      type: types.SET_AUTH_STATE,
      payload: localAuthState,
    });
    userProfile();
  } else {
    store.dispatch({
      type: types.INIT_AUTH_STATE,
    });
  }
})();

async function userProfile(dispatch = store.dispatch) {
  try {
    const resp = await UserService.profile();
    if (resp.data && resp.data.success) {
      const payload = {
        isLoggedIn: true,
        user: resp.data.data,
      };
      dispatch({ type: types.SET_AUTH_STATE, payload });
      let marketConfig = getMarketConfigFromStorage();
      if (!marketConfig) {
        marketConfig = await fetchMarketConfig();
        if (!marketConfig) {
          await new Promise((r) => setTimeout(r, 1500));
          marketConfig = await fetchMarketConfig();
        }
        if (marketConfig) {
          saveMarketConfigToStorage(marketConfig);
        }
      }
      if (marketConfig) {
        dispatch({ type: appTypes.SET_MARKET_CONFIG, payload: marketConfig });
      }
    } else {
      dispatch({ type: types.INIT_AUTH_STATE });
      removeAuthStorage();
    }
  } catch (err) {
    if (process.env.NODE_ENV === "development") console.error("User Profile error catch => ", err);
  }
}

function setAuthStorage() {
  localStorage.setItem(AUTH_STATE, JSON.stringify({ authToken: store.getState().auth_reducer.authToken }));
}

function removeAuthStorage() {
  if (localStorage.getItem(AUTH_STATE)) localStorage.removeItem(AUTH_STATE);
  clearMarketConfigFromStorage();
  store.dispatch({ type: appTypes.SET_MARKET_CONFIG, payload: null });
}

const actions = {
  userProfile,
  setAuthStorage,
  removeAuthStorage,
};

export { store as default };
export { types, actions };
